/* Centerfaced — currency-correct cart free-shipping progress.
   The real free-shipping discount triggers at $140 in the SHOP currency (AUD);
   static marketing copy elsewhere says "$100 USD" by design. This script keeps
   the cart-drawer progress bar ([data-cf-progress]) mathematically right in the
   shopper's presentment currency via Shopify.currency.rate, re-applied after
   every AJAX re-render via a MutationObserver (writes are diffed to avoid
   observer feedback loops). Server-rendered values are correct for AUD and act
   as the no-JS fallback. */
(function () {
  'use strict';

  function currency() {
    var rate = 1, cur = 'AUD';
    try {
      rate = parseFloat(window.Shopify.currency.rate) || 1;
      cur = window.Shopify.currency.active || 'AUD';
    } catch (e) {}
    return { rate: rate, cur: cur };
  }

  function fmt(amount, cur, decimals) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: cur,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals
      }).format(amount);
    } catch (e) {
      return '$' + Math.round(amount);
    }
  }

  function fixProgressBars() {
    var c = currency();
    document.querySelectorAll('[data-cf-progress]').forEach(function (el) {
      var goal = parseFloat(el.dataset.goalCents) * c.rate; // presentment cents
      var total = parseFloat(el.dataset.cartTotal);          // presentment cents
      if (!goal || isNaN(total)) return;
      var msg = el.querySelector('[data-cf-progress-msg]');
      var suc = el.querySelector('[data-cf-progress-success]');
      var fill = el.querySelector('[data-cf-progress-fill]');
      var reached = total >= goal;
      if (msg && msg.hidden !== reached) msg.hidden = reached;
      if (suc && suc.hidden !== !reached) suc.hidden = !reached;
      if (!reached) {
        var amtEl = el.querySelector('[data-cf-progress-amount]');
        if (amtEl) {
          var remaining = (goal - total) / 100;
          var txt = fmt(remaining, c.cur, remaining % 1 ? 2 : 0);
          if (amtEl.textContent !== txt) amtEl.textContent = txt;
        }
      }
      if (fill) {
        var w = Math.min(100, (total / goal) * 100).toFixed(1) + '%';
        if (fill.style.width !== w) fill.style.width = w;
      }
    });
  }

  function init() {
    fixProgressBars();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () { fixProgressBars(); })
        .observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
